import InlineRename from "controllers/admin/massimo/inline_rename_controller";

export default class extends InlineRename {}
